/* eslint-disable */
// App
const
  FRESH_TIMEOUT          = exports.FRESH_TIMEOUT = 850,
  PRIMARY_GRADIENT_ONE   = exports.PRIMARY_GRADIENT_ONE = process.env.REACT_APP_PRIMARY_GRADIENT_ONE,
  PUBLIC_URL             = exports.PUBLIC_URL = process.env.PUBLIC_URL,
  REACT_APP_PRIMARY_BLUE = exports.PRIMARY_BLUE = process.env.PRIMARY_BLUE,
  USE_STG                = exports.USE_STG = (process.env.REACT_APP_USE_STG == 'true'),
  REDIRECT_DOMAIN        = exports.REDIRECT_DOMAIN = process.env.REACT_APP_REDIRECT_DOMAIN,
  IS_POT_EIGHT           = exports.IS_POT_EIGHT = process.env.REACT_APP_IS_POT_EIGHT;

// Sentry
const
  ENV  = exports.ENV = process.env.REACT_APP_ENV;

// OpenPay
const
  FREE         = exports.FREE         = process.env.REACT_APP_PLAN_FREE,
  FREEMIUM     = exports.FREEMIUM     = process.env.REACT_APP_PLAN_FREEMIUM,

  BASIC        = exports.BASIC        = process.env.REACT_APP_PLAN_BASIC,
  BASIC_ANUAL  = exports.BASIC_ANUAL  = process.env.REACT_APP_PLAN_BASIC_ANUAL,

  GROWTH       = exports.GROWTH       = process.env.REACT_APP_PLAN_GROWTH,
  GROWTH_ANUAL = exports.GROWTH_ANUAL = process.env.REACT_APP_PLAN_GROWTH_ANUAL,

  PRO          = exports.PRO          = process.env.REACT_APP_PLAN_PRO,
  PRO_ANUAL    = exports.PRO_ANUAL    = process.env.REACT_APP_PLAN_PRO_ANUAL,

  OP_ID        = exports.OP_ID        = process.env.REACT_APP_OP_ID,
  OP_API_KEY   = exports.OP_API_KEY   = process.env.REACT_APP_OP_API_KEY,
  OP_SANDBOX   = exports.OP_SANDBOX   = (process.env.REACT_APP_OP_SANDBOX == 'true');

// Pusher
const
  PUSHER_API_KEY = exports.PUSHER_API_KEY = process.env.REACT_APP_PUSHER_API_KEY;

// Segment
const
  SEGMENT_KEY         = exports.SEGMENT_KEY         = process.env.REACT_APP_SEGMENT_KEY,
  SEGMENT_PORTAL_KEY  = exports.SEGMENT_PORTAL_KEY  = process.env.REACT_APP_SEGMENT_PORTAL_KEY;

// Product Tour
const
  PRODUCT_TOUR_ID = exports.PRODUCT_TOUR_ID = process.env.REACT_APP_PRODUCT_TOUR_ID;

// Payments
const
  OXXO_PUBLIC = exports.OXXO_PUBLIC = process.env.REACT_APP_PAYMENT_OXXO_PUBLIC;

// Integrations
const
  NEW_INTEGRATIONS_SAT = exports.NEW_INTEGRATIONS_SAT = process.env.REACT_APP_NEW_INTEGRATIONS_SAT,
  REACT_APP_NEW_INTEGRATIONS_PUE_PAID = exports.REACT_APP_NEW_INTEGRATIONS_PUE_PAID = process.env.REACT_APP_NEW_INTEGRATIONS_PUE_PAID,
  REACT_APP_INTEGRATIONS_CONTPAQI = exports.REACT_APP_INTEGRATIONS_CONTPAQI = process.env.REACT_APP_INTEGRATIONS_CONTPAQI,
  CONTPAQI_NEW_FEATURES = exports.CONTPAQI_NEW_FEATURES = process.env.REACT_APP_CONTPAQI_NEW_FEATURES;

// CFDI
const
  CANCELLED_CFDI       = exports.CANCELLED_CFDI       = process.env.REACT_APP_PAYMENT_CANCELLED_CFDI,
  CFDI_EMIT_IN_PAYMENT = exports.CFDI_EMIT_IN_PAYMENT = process.env.REACT_APP_CFDI_EMIT_IN_PAYMENT,
  CANCEL_INVOCIE       = exports.CANCEL_INVOCIE       = process.env.REACT_APP_CANCEL_INVOICE;

// IMPORT
const
IMPORT_XLS     = exports.IMPORT_XLS = process.env.REACT_APP_IMPORT_XLS,
IMPORT_CLIENTS = exports.IMPORT_CLIENTS = process.env.REACT_APP_IMPORT_CLIENTS;

// CREDIT_NOTE
const
  CREDIT_NOTE = exports.CREDIT_NOTE = process.env.REACT_APP_CREDIT_NOTE;

// CLIENT_EXPEDIENT
const
  CLIENT_EXPEDIENT = exports.CLIENT_EXPEDIENT = process.env.REACT_APP_CLIENT_EXPEDIENT,
  CLIENT_REMINDERS = exports.CLIENT_REMINDERS = process.env.REACT_APP_CLIENT_REMINDERS;

// INTEGRATIONS
const TOKEN_INTEGRATIONS = exports.TOKEN_INTEGRATIONS = process.env.REACT_APP_TOKEN_VALIDATE_RFC;



// WEBPACK FOOTER //
// ./src/constants/app.js